export const COOKIE_CONSENT_ACCEPTED_KEY = "cargorunCookieConsentAccepted";
export const CAN_RESET_DISTRIBUTION_BID_IN_PROCESS_STATUS_KEY = "canResetDistributionBidInProcessStatus";
